module.exports = __webpack_public_path__ + "static/media/pointing-arrow.c26166f0.svg";